import { Hammer, Wrench, Search, Siren, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const SERVICES = [
  {
    icon: Hammer,
    title: "Roof Installation",
    desc: "Full tear-off and new system installs with manufacturer-certified materials. Built for decades, not seasons.",
  },
  {
    icon: Wrench,
    title: "Roof Repair",
    desc: "Leak diagnosis, shingle replacement, flashing rebuilds. Surgical fixes that hold under every storm.",
  },
  {
    icon: Search,
    title: "Roof Inspection",
    desc: "Detailed 27-point inspections with photo reports. Insurance-grade documentation, no upsells.",
  },
  {
    icon: Siren,
    title: "Emergency Services",
    desc: "Storm damage, sudden leaks, fallen branches — 24/7 tarp and stabilize crews on call across the region.",
  },
];

export default function Services({ onOpenEstimate }) {
  // onOpenEstimate currently unused on home — kept for API stability
  void onOpenEstimate;
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative shingle-texture bg-[var(--crest-slate)] py-24 md:py-32"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="max-w-3xl mb-16 md:mb-20">
          <div className="reveal flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[var(--crest-amber)]" />
            <span className="font-display uppercase tracking-[0.4em] text-xs font-semibold text-[var(--crest-amber)]">
              What We Do
            </span>
          </div>
          <h2
            data-testid="services-heading"
            className="reveal font-display uppercase font-extrabold text-white leading-[0.95] tracking-tight"
            style={{ fontSize: "clamp(2.4rem, 5.5vw, 4.5rem)" }}
          >
            Our Services.
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${i}`}
                className="reveal card-lift relative bg-[#141d2e] border border-white/10 border-t-2 border-t-[var(--crest-amber)] p-8 md:p-10 flex flex-col min-h-[280px]"
                style={{ transitionDelay: `${i * 90}ms` }}
              >
                <Icon
                  size={36}
                  strokeWidth={1.5}
                  className="text-[var(--crest-amber)] mb-8"
                />
                <h3 className="font-display uppercase font-bold text-2xl md:text-[1.65rem] text-white tracking-tight mb-4">
                  {s.title}
                </h3>
                <p className="font-body text-sm text-white/65 leading-relaxed">
                  {s.desc}
                </p>
                <span className="font-display uppercase tracking-[0.3em] text-[10px] text-white/30 mt-auto pt-6">
                  0{i + 1}
                </span>
              </div>
            );
          })}
        </div>

        {/* Ghost CTA */}
        <div className="reveal mt-14 flex justify-center">
          <Link
            to="/services"
            data-testid="services-see-all"
            className="group inline-flex items-center gap-3 font-display uppercase tracking-[0.3em] text-sm font-semibold text-white/80 hover:text-[var(--crest-amber)] border-b border-white/20 hover:border-[var(--crest-amber)] pb-2 transition-colors"
          >
            See All Services
            <ArrowRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </Link>
        </div>
      </div>
    </section>
  );
}
